import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// Format the number with commas and two decimal places
const formatNumber = (value) => {
  if (value === null || value === undefined) return '0.00';
  
  const numericValue = parseFloat(value).toFixed(2);
  const parts = numericValue.split(".");
  
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  
  return parts.join(".");
};

const FormattedNumberInput = ({ initialValue = '0.00', onSave, onCancel }) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue); // Store raw value

  // Handle input value change
  const handleValueChange = (e) => {
    const inputValue = e.target.value.replace(/,/g, ''); // Remove commas for parsing
    setValue(inputValue); // Store the unformatted value
  };

  // Handle save value
  const handleSave = () => {
    const numericValue = parseFloat(value).toFixed(2);
    onSave(numericValue);
  };

  const handleCancel = () => {
    onCancel();
  };

  // Handle input blur to format the value when the input loses focus
  const handleBlur = () => {
    const numericValue = parseFloat(value).toFixed(2);
    setValue(numericValue); // Update the value to a formatted version
  };

  return (
    <div>
      <input
        type="text"
        value={value} // Use raw value for input
        onChange={handleValueChange}
        onBlur={handleBlur} // Format the value on blur
        className="input input-bordered w-full"
        placeholder={t('app:crm.t28')}
      />
      <div className="flex justify-start space-x-6 mt-4">
        <button onClick={handleSave} className="btn btn-xs cursor-pointer">
          {t('app:crm.t4')}
        </button>
        <button onClick={handleCancel} className="btn btn-xs cursor-pointer">
          {t('app:crm.t5')}
        </button>
      </div>
    </div>
  );
};

export default FormattedNumberInput;
